import { AdmSiteConfig } from '@pubstack/common/src/siteConfig'
import { TamConfig } from '@pubstack/common/src/tam/tamConfig'
import { useAtomValue } from 'jotai'
import { FunctionComponent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTamConfig, useTamSiteConfig } from '~/api/adm-api.hook'
import { useToast } from '~/components/Toast/useToasts'
import { configurationState } from '~/state'
import { PureAdmTamIntegrationPage } from './PureAdmTamIntegrationPage'

export const AdmTamIntegrationPage: FunctionComponent = () => {
  const [tamConfig, setTamConfig] = useState<TamConfig>({ scopeId: '', apsPubId: '', siteConfigs: [], sites: [] })
  const toast = useToast()
  const navigate = useNavigate()
  const { byId: tamConfigById } = useTamConfig(null)
  const { byId: tamSiteConfigById } = useTamSiteConfig(null)
  const { STATIC_ASSETS_CDN } = useAtomValue(configurationState)

  const getCurrentTamConfig = async () => {
    const res = await tamConfigById.get()
    setTamConfig(res)
  }

  const onCreatePublisherId = async (publisherId: string) => {
    try {
      const res = await tamConfigById.put(publisherId)
      setTamConfig(res)
      toast.success(`The publisher id has been saved.`)
    } catch (_err) {
      toast.alert('An error occurred when trying to save the publisher id.')
    }
  }

  const onCreateSiteConfig = async (siteConfig: AdmSiteConfig) => {
    try {
      await tamSiteConfigById.put(siteConfig)
      await getCurrentTamConfig()
      toast.admSuccess(tamConfig.sites.find((site) => site.id === siteConfig.siteId)?.name ?? '', true, navigate)
    } catch (_err) {
      toast.alert(`An error occurred when trying to save the site configuration.`)
    }
  }

  useEffect(() => {
    // Legitimate data load on mount (async fetch then setState).
    // oxlint-disable-next-line react/set-state-in-effect
    getCurrentTamConfig()
  }, [])

  return (
    <PureAdmTamIntegrationPage
      isLoading={tamConfigById.loading}
      tamConfig={tamConfig}
      onCreatePublisherId={onCreatePublisherId}
      onCreateSiteConfig={onCreateSiteConfig}
      baseCDNUrl={STATIC_ASSETS_CDN}
    />
  )
}
